import IAudit from "./IAudit";

export interface IAuditHistoryEventDTO {
    id: number;
    otsikko: string;
    aikaleima: string;
    kuvaus: string;
    tyyppi: string;
    suorittaja: number;
    historiapaketti_id: string;
    auditointi: IAudit["id"];
};

export enum EAuditEventType {
    Finished = "valmis",
    InProgress = "kesken",
    Conversion = "konversio"
};

export interface IAuditHistoryEvent {
    id: number;
    title: string;
    description: string;
    timestamp: string;
    type: EAuditEventType;
    performer: number;
    historyPackageId: string;
    audit: IAudit["id"]
};

export type IAuditHistoryEventMeta = Pick<IAuditHistoryEvent, "title" | "description" | "type">;

export type INewAuditHistoryEvent = Omit<IAuditHistoryEvent, "id">;
export type INewAuditHistoryEventDTO = Omit<IAuditHistoryEventDTO, "id">;



export const AuditHistoryEventMapper = {
    apiToDomain: (api: IAuditHistoryEventDTO): IAuditHistoryEvent => {
        return {
            id: api.id,
            title: api.otsikko,
            timestamp: api.aikaleima,
            description: api.kuvaus,
            type: api.tyyppi as EAuditEventType,
            performer: api.suorittaja,
            historyPackageId: api.historiapaketti_id,
            audit: api.auditointi
        }
    },

    domainToApi: (domain: IAuditHistoryEvent): IAuditHistoryEventDTO => {
        return {
            id: domain.id,
            otsikko: domain.title,
            aikaleima: domain.timestamp,
            kuvaus: domain.description,
            tyyppi: domain.type,
            suorittaja: domain.performer,
            historiapaketti_id: domain.historyPackageId,
            auditointi: domain.audit
        }
    }
};


export const NewAuditHistoryEventMapper = {
    domainToApi: (domain: INewAuditHistoryEvent): INewAuditHistoryEventDTO => {
        return {
            otsikko: domain.title,
            aikaleima: domain.timestamp,
            kuvaus: domain.description,
            tyyppi: domain.type,
            suorittaja: domain.performer,
            historiapaketti_id: domain.historyPackageId,
            auditointi: domain.audit
        }
    }
};